<template>
  <div v-show="visible" style="position: absolute;top: 0px;left: 0px;width: calc(100vw);height:calc(100vh);display: flex;justify-content: center;align-items: center;position: fixed;z-index: 999;">
    <transition name="alert-slide" @after-enter="$emit('opened')" @after-leave="$emit('closed')">
      <div v-show="visible" class="m-alert">
        <slot></slot>
      </div>
    </transition>
    <v-shadow v-show="visible && shadow" ref="shadow" @click="hide()" :z-index="100" :backgroundColor="backgroundColor"></v-shadow>
  </div>
</template>

<script>
  import vShadow from './shadow';

  export default {
    name: 'm-alert',
    props: {
      shadow: {
        type: Boolean,
        default: true
      },
      backgroundColor:{
        type:String,
        default: 'rgba(0, 0, 0, 0.5)'
      }
    },
    components: {
      vShadow
    },
    data() {
      return {
        visible: false
      };
    },
    methods: {
      show(time) {
        this.visible = true;
        if (time && typeof time === 'number') {
          setTimeout(() => {
            this.visible = false
          }, time)
        }
      },
      hide() {
        this.visible = false;
      }
    }
  };
</script>

<style lang="scss">
  .m-alert {
    box-sizing: border-box;
    transition: transform 0.3s;
    position: relative;
    z-index: 101;
    overflow-y: auto;
    background-color: white;
    width:96.5%;
    height:80%;
  }
  @-webkit-keyframes alert-slide-in {
    0% {
      -webkit-transform: translateY(-15px);
      transform: translateY(-15px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateY(0);
      transform: translateY(0);
      opacity: 1;
    }
  }
  @keyframes alert-slide-in {
    0% {
      -webkit-transform: translateY(-15px);
      transform: translateY(-15px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateY(0);
      transform: translateY(0);
      opacity: 1;
    }
  }
  @-webkit-keyframes alert-slide-out {
    0% {
      -webkit-transform: translateY(0);
      transform: translateY(0);
      opacity: 1;
    }
    100% {
      -webkit-transform: translateY(-15px);
      transform: translateY(-15px);
      opacity: 0;
    }
  }
  @keyframes alert-slide-out {
    0% {
      -webkit-transform: translateY(0);
      transform: translateY(0);
      opacity: 1;
    }
    100% {
      -webkit-transform: translateY(-15px);
      transform: translateY(-15px);
      opacity: 0;
    }
  }
  .alert-slide-enter-active {
    -webkit-animation: alert-slide-in 0.3s ease;
    animation: alert-slide-in 0.3s ease;
  }
  .alert-slide-leave-active {
    -webkit-animation: alert-slide-out 0.3s ease;
    animation: alert-slide-out 0.3s ease;
  }
</style>
